import dayjs, { Dayjs } from "dayjs";
import React from "react";

function getSuffix(d: dayjs.Dayjs, deliveryDateString: string | undefined) {
  if (d.isSame(dayjs(), "d")) {
    return "(Today)";
  }
  if (d.isSame(dayjs().add(1, "day"), "d")) {
    return "(Tomorrow)";
  }
  if (d.isSame(dayjs().subtract(1, "day"), "d")) {
    return "(Yesterday)";
  }
  if (d.isSame(dayjs().add(2, "day"), "d")) {
    return `${deliveryDateString ?? ""}`;
  }
  return "";
}

export function renderDate(d: Dayjs, deliveryDateString?: string): React.JSX.Element {

  const suffix = getSuffix(d, deliveryDateString);

  return (
    <div>
      { d.format("ddd Do MMM YYYY") }
      { " " }
      { suffix && (
        <span className="font-bold">
          { suffix }
        </span>
      ) }
    </div>
  );
}
